/**
 * @author      xinzhe.chai@zumper.com (Xinzhe Chai)
 * @copyright   Copyright (c) 2021, Zumper
 */

import * as React from 'react'

import { IconProps } from '../../types'

export const Zumper = ({ size = 29 }: IconProps) => {
  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 94 94"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M52.8466 70.7743C53.9889 70.7743 54.7504 71.5358 54.7504 72.678V92.0966C54.7504 93.2388 55.5119 94.0004 56.6542 94.0004H76.0727C77.215 94.0004 77.9765 93.2388 77.9765 92.0966V59.7323C77.9765 59.3516 78.3573 58.9708 78.3573 58.9708H84.8301C86.7339 58.9708 87.8761 57.067 86.3531 55.544L74.1689 43.3598C73.7882 42.9791 73.7882 42.5983 73.7882 41.8368V26.9873C73.7882 25.8451 73.0267 25.0836 71.8844 25.0836H64.2693C63.127 25.0836 62.3655 25.8451 62.3655 26.9873V31.9372L48.2775 17.8492C47.516 17.0877 46.3738 17.0877 45.6123 17.8492L7.53669 55.9248C6.39442 57.067 7.15593 59.3516 9.05971 59.3516H15.5326C15.9133 59.3516 16.2941 59.7323 16.2941 59.7323V92.0966C16.2941 93.2388 17.0556 94.0004 18.1979 94.0004H37.6164C38.7587 94.0004 39.5202 93.2388 39.5202 92.0966V72.678C39.5202 71.5358 40.2817 70.7743 41.4239 70.7743H52.8466Z"
        fill="#38CCFF"
      />
      <path
        d="M78.3577 4.90331C77.5962 -1.95029 70.3618 -1.18878 68.458 4.52255C68.458 4.90331 68.0773 4.90331 68.0773 4.52255C65.7927 -1.56954 58.1776 -1.56954 57.7969 5.66482C57.7969 12.1377 65.0312 15.1837 67.6965 19.372C68.0773 19.7528 68.458 19.7528 68.8388 19.372C71.5041 14.803 79.1192 11.3762 78.3577 4.90331Z"
        fill="#FF0082"
      />
    </svg>
  )
}
